import React, { ReactNode } from 'react';
import { twMerge } from 'utilities/src/twMerge';
import AuthorImage from './AuthorImage';
import AuthorName from './AuthorName';
import AuthorDescription from './AuthorDescription';

export type AuthorProps = {
  children: ReactNode;
  align?: 'center' | 'top';
  classes?: string;
};

function AuthorComponent({ children, align = 'top', classes = '' }: AuthorProps) {
  return (
    <div
      className={twMerge(
        'flex',
        { 'items-center': align === 'center' },
        { 'items-start': align === 'top' },
        classes,
      )}
    >
      {children}
    </div>
  );
}

const Author = Object.assign(AuthorComponent, {
  Image: AuthorImage,
  Name: AuthorName,
  Description: AuthorDescription,
});

export default Author;
